import { Component } from '@theme/component';

/** @extends {Component<{track: HTMLUListElement, previous: HTMLButtonElement, next: HTMLButtonElement}>} */
class MitoqHomeGoals extends Component {
  requiredRefs = ['track', 'previous', 'next'];
  #abort;
  #resize;

  connectedCallback() {
    super.connectedCallback();
    this.#connect();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#connect();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#resize?.disconnect();
    super.disconnectedCallback();
  }

  #connect() {
    this.#abort?.abort();
    this.#resize?.disconnect();
    this.#abort = new AbortController();
    this.refs.track.addEventListener('scroll', this.syncControls, { passive: true, signal: this.#abort.signal });
    this.#resize = new ResizeObserver(this.syncControls);
    this.#resize.observe(this.refs.track);
    this.syncControls();
  }

  syncControls = () => {
    const { track, previous, next } = this.refs;
    const offset = Math.abs(track.scrollLeft);
    previous.disabled = offset < 2;
    next.disabled = offset >= track.scrollWidth - track.clientWidth - 2;
  };

  previous() { this.#move(-1); }
  next() { this.#move(1); }

  /** @param {number} direction */
  #move(direction) {
    const track = this.refs.track;
    const first = track.firstElementChild;
    if (!(first instanceof HTMLElement)) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: direction * rtl * (first.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'instant' : 'smooth' });
    if (reduceMotion) this.syncControls();
  }
}

if (!customElements.get('mitoq-home-goals')) customElements.define('mitoq-home-goals', MitoqHomeGoals);
